var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledleftp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.47949,
    y: 3.91772,
    width: 9.27854,
    height: 9.27854,
    rx: 3.47945,
    fill: "#B2B5BB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.47949,
    y: 15.5161,
    width: 9.27854,
    height: 9.27854,
    rx: 3.47945,
    fill: "#B2B5BB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0776,
    y: 3.91772,
    width: 9.27854,
    height: 9.27854,
    rx: 3.47945,
    fill: "#B2B5BB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.0776,
    y: 15.5161,
    width: 9.27854,
    height: 9.27854,
    rx: 3.47945,
    fill: "#B2B5BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledleftp);
export default __webpack_public_path__ + "static/media/filled leftp.15ed7defba30518018c5a1a79ec17a6e.svg";
export { ForwardRef as ReactComponent };